module.exports = __webpack_public_path__ + "img/model-fbzs.23e7cb4b.jpg";